export default __webpack_public_path__ + "static/media/red_Scanner.977e3156.svg";